/**
 * Kaydirma ile beliren icerik.
 *
 * Ogeler ekrana girdiginde yumusakca yukari suzulur. Elemanlara elle
 * data-reveal yazmak yerine secici listesinden otomatik toplanir; boylece
 * yeni bir bolum eklendiginde animasyon kendiliginden calisir.
 */
(() => {
  const REVEAL_SELECTORS = [
    '.section-head',
    '.mosaic__item',
    '.featured__item',
    '.banner__content',
    '.card',
  ].join(',');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hareket azaltma tercihinde animasyon hic kurulmaz. Sadece suresini sifira
  // indirmek yetmez: ogeler opacity:0 ile baslayacagi icin, IntersectionObserver
  // herhangi bir sebeple calismazsa icerik gorunmez kalirdi.
  if (reduceMotion) return;

  const targets = document.querySelectorAll(REVEAL_SELECTORS);
  if (targets.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        // Bir kez belirdikten sonra izlemeyi birak: yukari kaydirinca
        // tekrar solup gelmesi rahatsiz edici olur.
        observer.unobserve(entry.target);
      });
    },
    {
      // Ogenin ust kenari ekranin altina 12% girdiginde tetiklenir; tam
      // ekrana girmesini beklemek animasyonu gec ve kacik hissettirir.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0,
    }
  );

  targets.forEach((el) => {
    el.classList.add('reveal');
    observer.observe(el);
  });
})();

/**
 * Yumusak otomatik hizalama (smooth section snap).
 *
 * Amac: bolumler arasi "otomatik hizalama" hissi, ama native CSS scroll-snap'in
 * "cekme/direnme" hissi OLMADAN.
 *
 * Nasil: kaydirirken sayfa tamamen serbesttir. Kullanici DURUNCA (kisa bir
 * bekleme sonrasi) en yakin bolumun ust kenari, sabit header'in altina
 * yumusak ve eased bir animasyonla hizalanir. Kullanici tekrar kaydirirsa
 * (tekerlek/parmak/tus) animasyon ANINDA iptal olur -- yani hicbir zaman
 * kullaniciyla yarismaz.
 *
 * Devreye GIRMEDIGI durumlar: dar ekran (mobil dokunmatik), hareket azaltma,
 * modal/cekmece acik, form alaninda yaziyorken, sayfanin en tepesi/dibi
 * (footer serbest kalir) ve uzun bir bolumun ortasinda okurken (en yakin
 * kenar esik mesafesinden uzaksa hizalama yapilmaz).
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Tema ayari: otomatik bolum hizalama yalnizca acikken (body[data-auto-snap]).
  if (!document.body.hasAttribute('data-auto-snap')) return;

  const desktop = window.matchMedia('(min-width: 990px)');

  const SETTLE_MS = 90;          // kaydirma bittikten sonra beklenen sure (atik)
  const MIN_DUR = 220;           // en kisa hizalama suresi (kisa mesafe = neredeyse anlik)
  const MAX_DUR = 460;           // en uzun hizalama suresi (uzun mesafe yine akici)
  const MIN_MOVE = 6;            // bu kadar yakinsa zaten hizali say (px)
  const THRESHOLD_RATIO = 0.35;  // en yakin kenar bu*viewport'tan uzaksa hizalama yok
  const ease = (t) => 1 - Math.pow(1 - t, 3); // easeOutCubic -- cevik ve smooth

  let settleTimer = null;
  let rafId = 0;
  let animating = false;

  const headerHeight = () => {
    const v = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-h'));
    if (v) return v;
    const h = document.querySelector('.header');
    return h ? h.offsetHeight : 0;
  };

  const cancelAnim = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    animating = false;
  };

  const animateBy = (dist) => {
    const startY = window.scrollY;
    const start = performance.now();
    // Sure mesafeye gore: kisa hizalama neredeyse anlik, uzun hizalama akici.
    // Boylece animasyon scroll davranisina "atik" tepki verir.
    const dur = Math.max(MIN_DUR, Math.min(MAX_DUR, Math.abs(dist) * 1.05));
    animating = true;
    const step = (now) => {
      const p = Math.min(1, (now - start) / dur);
      // behavior:'instant' sart: CSS'teki scroll-behavior:smooth ile carpismasin.
      window.scrollTo({ top: startY + dist * ease(p), left: 0, behavior: 'instant' });
      if (p < 1) {
        rafId = requestAnimationFrame(step);
      } else {
        rafId = 0;
        animating = false;
      }
    };
    rafId = requestAnimationFrame(step);
  };

  const maybeSnap = () => {
    if (animating || !desktop.matches) return;
    // Modal/cekmece aciksa sayfa kilitlidir -- dokunma.
    if (document.documentElement.style.overflow === 'hidden') return;
    // Form alaninda yaziyorsa dokunma.
    const ae = document.activeElement;
    if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return;

    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    const maxScroll = document.documentElement.scrollHeight - vh;

    // En tepe ya da en dip (footer): serbest birak.
    if (scrollY <= MIN_MOVE || scrollY >= maxScroll - MIN_MOVE) return;

    const headerH = headerHeight();
    const vhContent = vh - headerH;
    const sections = document.querySelectorAll('main > .shopify-section');
    let best = 0;
    let bestAbs = Infinity;

    for (const s of sections) {
      const rect = s.getBoundingClientRect();

      // Kendi scroll davranisi olan bolumler ([data-no-snap] iceren, or.
      // "Her Parça Elde Doğar"): bu bolum icerik viewport'unun yarisindan
      // fazlasini kapliyorsa otomatik hizalama TAMAMEN devre disi; ayrica
      // kenarlarina da hic hizalanma.
      if (s.querySelector('[data-no-snap]')) {
        const overlap = Math.min(rect.bottom, vh) - Math.max(rect.top, headerH);
        if (overlap > vhContent * 0.5) return;
        continue;
      }

      // Bu bolumu hizalamak icin gereken isaretli mesafe (+ asagi, - yukari).
      const dist = rect.top - headerH;
      const abs = Math.abs(dist);
      if (abs < bestAbs) {
        bestAbs = abs;
        best = dist;
      }
    }

    // Zaten hizali ya da cok uzak (uzun bolumun ortasi) -> bir sey yapma.
    if (bestAbs < MIN_MOVE || bestAbs > vh * THRESHOLD_RATIO) return;
    animateBy(best);
  };

  const onScroll = () => {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(maybeSnap, SETTLE_MS);
  };

  // Kullanici girdisi bekleyen/suren hizalamayi iptal etsin: asla direnme.
  const onUserIntent = () => {
    if (settleTimer) clearTimeout(settleTimer);
    cancelAnim();
    settleTimer = setTimeout(maybeSnap, SETTLE_MS);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('wheel', onUserIntent, { passive: true });
  window.addEventListener('touchstart', onUserIntent, { passive: true });
  window.addEventListener('keydown', (e) => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(e.key)) {
      onUserIntent();
    }
  });
})();
